module.exports = __webpack_public_path__ + "static/if-you-want-to-write-eca5e2bd5828e147ced76f56067a4152.jpg";